"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.appendElement = void 0;
exports.checkDocumentHidden = checkDocumentHidden;

/**
 * 在 DOM 结构中载入一些公用元素，如评论、分享组件，
 * 默认 append 到 body 下，还可以指定特定的父容器
 *
 * 如果 #containerId 已经存在，则不会再次 append
 *
 * @param {string} containerId 需要 append 的元素的容器 ID
 * @param {string} [parentClassName] 指定元素要 append 到的父容器的类
 * @returns {HTMLElement} 被插入的元素
 */
var appendElement = function appendElement(containerId, parentClassName) {
  var _document$getElements;

  var container = document.getElementById(containerId);

  if (container) {
    return container;
  }

  var newContainer = document.createElement('div');
  newContainer.setAttribute('id', containerId);
  var target = parentClassName ? (_document$getElements = document.getElementsByClassName(parentClassName)[0]) !== null && _document$getElements !== void 0 ? _document$getElements : document.body : document.body;
  target.appendChild(newContainer);
  return newContainer;
};

exports.appendElement = appendElement;

function checkDocumentHidden(cb) {
  window.setTimeout(function () {
    if (!document.hidden) {
      cb();
    }
  }, 1000);
}